import * as i0 from '@angular/core';
import * as i1 from './tooltip.module';
import * as i2 from './tooltip';
export const NgbTooltipModuleNgFactory:i0.NgModuleFactory<i1.NgbTooltipModule> = (null as any);
var _decl0_0:i2.NgbTooltip = (<any>(null as any));
var _decl0_1:i2.NgbTooltipWindow = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
function _View_NgbTooltipWindow_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NgbTooltipWindow_1_0():void {
  var _any:any = (null as any);
}
